import { useEffect, useState } from "react";
import PrimaryButton from "../../../components/button/PrimaryButton";
import {
  getMyEmployeeProfile,
  updateMyEmployeePassword,
} from "../../../services/employees";

const MyAccount = () => {
  const [profile, setProfile] = useState(null);
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmation: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getMyEmployeeProfile()
      .then(setProfile)
      .catch((requestError) => setError(requestError.message));
  }, []);

  const update = (field, value) =>
    setPasswords((current) => ({ ...current, [field]: value }));

  const submit = async () => {
    if (
      passwords.currentPassword.length < 5 ||
      passwords.newPassword.length < 5
    ) {
      return setError("Passwords must be at least 5 characters.");
    }

    if (passwords.newPassword !== passwords.confirmation)
      return setError("New passwords do not match.");
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      await updateMyEmployeePassword(
        passwords.currentPassword,
        passwords.newPassword,
      );
      setPasswords({ currentPassword: "", newPassword: "", confirmation: "" });
      setSuccess("Password updated. You remain signed in.");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto grid max-w-4xl gap-6 md:grid-cols-2">
      <section className="rounded bg-white p-6 shadow">
        <h1 className="mb-5 text-xl font-bold uppercase text-slate-700">
          My Account
        </h1>
        {profile ? (
          <dl className="space-y-3 text-sm">
            <Info
              label="Name"
              value={`${profile.firstName} ${profile.lastName}`}
            />
            <Info label="Email" value={profile.email} />
            <Info label="Phone" value={profile.phoneNumber || "—"} />
            <Info label="Address" value={profile.address || "—"} />
          </dl>
        ) : (
          <p className="text-sm text-slate-500">Loading account details…</p>
        )}
      </section>
      <section className="rounded bg-white p-6 shadow">
        <h2 className="mb-5 text-xl font-bold uppercase text-slate-700">
          Change Password
        </h2>
        {error ? (
          <div
            role="alert"
            className="mb-4 rounded bg-red-50 p-3 text-sm text-red-700"
          >
            {error}
          </div>
        ) : null}
        {success ? (
          <div
            role="status"
            className="mb-4 rounded bg-emerald-50 p-3 text-sm text-emerald-700"
          >
            {success}
          </div>
        ) : null}
        <div className="space-y-4">
          <PasswordInput
            label="Current Password"
            value={passwords.currentPassword}
            onChange={(value) => update("currentPassword", value)}
          />
          <PasswordInput
            label="New Password"
            value={passwords.newPassword}
            onChange={(value) => update("newPassword", value)}
          />
          <PasswordInput
            label="Confirm New Password"
            value={passwords.confirmation}
            onChange={(value) => update("confirmation", value)}
          />
          <div className="flex justify-end">
            <PrimaryButton
              title="Update Password"
              onClick={submit}
              isBusy={saving}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

const Info = ({ label, value }) => (
  <div>
    <dt className="font-semibold text-slate-500">{label}</dt>
    <dd className="text-slate-800">{value}</dd>
  </div>
);
const PasswordInput = ({ label, value, onChange }) => (
  <label className="block text-sm font-semibold text-slate-700">
    {label}
    <input
      aria-label={label}
      type="password"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="mt-1 w-full rounded border border-slate-300 px-3 py-2"
    />
  </label>
);

export default MyAccount;
